export const reasonableTypographyConfig: TypographyConfig = {
    H1: { fontSize: "40", fontWeight: "700", fontStyle: "normal" },  // Main heading
    H2: { fontSize: "33", fontWeight: "600", fontStyle: "normal" },  // Subheading
    H3: { fontSize: "24", fontWeight: "500", fontStyle: "normal" },  // Smaller subheading
    H4: { fontSize: "24", fontWeight: "500", fontStyle: "normal" },  // Section titles
    H5: { fontSize: "20", fontWeight: "500", fontStyle: "normal" },  // Subsection titles
    H6: { fontSize: "16", fontWeight: "400", fontStyle: "normal" },  // Minor titles
    "Body Font": { fontSize: "16", fontWeight: "400", fontStyle: "normal" },
}
import { Config } from "src/types";
import { newData } from "../templates/design1/components";
import { TypographyConfig } from "src/app/lib/useCssGenerator";
const mockServices = newData.map((item) => {
    return item.assessor
});
const aboutCompany = `
<p>Founded in 2012, Real Estate Demo is a forward-thinking real estate firm dedicated to redefining the modern property experience across Africa and beyond. What began as a small team of property enthusiasts has grown into a full-fledged company that manages hundreds of residential, commercial, and luxury properties for a diverse clientele. With our headquarters situated in the heart of Lagos, Nigeria, our operations extend to key cities such as Abuja, Port Harcourt, Accra, Nairobi, and Johannesburg.</p>
<p>Our mission is to bridge the gap between people and their dream spaces. Whether it’s buying, renting, or short-letting, we believe finding a place to live, work, or invest in should be seamless, secure, and transparent. Zenith Haven Realty leverages cutting-edge technology, data-driven insights, and a client-first approach to ensure every customer receives personalized, timely, and professional service at every touchpoint.</p>

<p>With over a decade of experience in property management, facility oversight, and tenant relations, our team of certified agents and legal consultants work tirelessly to ensure that both landlords and tenants experience the highest standard of service. We pride ourselves on our reputation for integrity, speed, and efficiency in handling even the most complex real estate needs.</p>

<p>At Zenith Haven Realty, our core values—Excellence, Trust, Innovation, and Empathy—guide every decision we make. These values are not just words on a wall but the very pillars that support the relationships we build with our clients, staff, and partners. In a rapidly changing world, we remain committed to sustainable housing, community development, and promoting inclusive economic growth through responsible real estate practices.</p>

<p>We invite you to experience the Zenith difference—where every property is more than a transaction; it’s a story, a dream, and a future brought to life. Whether you’re a first-time buyer, an international investor, or a family looking to relocate, Zenith Haven Realty is your trusted partner every step of the way.</p>
`;


const hardcodedConfig: Config = {
    agentId: "demo",
    template: "design1",
    styling: {
        primaryColor: "#2563EB",
        secondaryColor: "#2563EB",
        fontFamily: "Lato",
        fontSizeBase: "16px",
        h1Size: "44px",
        h2Size: "32px",
        h3Size: "28px",
        h4Size: "22px",
        h5Size: "18px",
        h6Size: "14px",
    },
    metadata: {
        siteName: "Real Estate Demo",
        description: "Explore properties with Real Estate Demo",
        keywords: "real estate",
    },
    websiteSettings: {
        sponsored_logo: true,
        modules_listing: true,
        about_us_display: true,
        services_contact_page: true,
        staffs_branch_options: true,
        social_link_visibility: true,
        sale_properties: true,
        rent_properties: true,
        shortlet_properties: true,
        typography: reasonableTypographyConfig,
    },
    companyInfo: {
        name: "Real Estate Demo",
        company_logo:
            "https://www.startpage.com/av/proxy-image?piurl=https%3A%2F%2Fthumbs.dreamstime.com%2Fz%2Fdemo-sign-icon-vector-170323553.jpg&sp=1744658885Tc252764b59b893ab10a050c4be906304d184a7ab3395adee39d3adbc0029b7bb",
        email: "ourproperty.com.ng",
        phone_number: [
            "+2349034556754",
            "+2349034556754",
            "+2349034556754",
            "+2349034556754",
        ],
        head_office_address: "No 24, Kajola Way, Agilinti, Lagos",
        full_address: "No 24, Kajola Way, Agilinti, Lagos",
        state: "Oyo",
        local_government: "Ido",
        city: "Ibadan",
        facebook: "facebook.com",
        x: "facebook.com",
        instagram: "facebook.com",
        linkedin: "facebook.com",
        youtube: "facebook.com",
        tiktok: "facebook.com",
        about: aboutCompany,
    },
    companyServices: mockServices,
    companyStat: {
        total_properties: 120,
        years_in_industry: "20 years +",
        total_branch: 5,
        total_staff: 50,
        properties_for_rent: 30,
        properties_for_sale: 40,
        properties_for_short_let: 20,
        total_units_managing: 60,
        total_reviews: 200,
        completed_transaction: 150,
    },
};

// 👇 Direct export — prefers localStorage if available
export const mockConfig: Config =
    typeof window !== "undefined" && localStorage.getItem("themeConfig")
        ? JSON.parse(localStorage.getItem("themeConfig") as string)
        : hardcodedConfig;
